import { IconButton, Stack, Typography } from '@mui/material';
import { RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import PropTypes from 'prop-types';

export default function InteractiveInterview({
  methods
}) {
  return (
    <Stack>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb="30px"
      >
        <Typography variant="subheading1" fontSize={18}>
          Interactive Interview
        </Typography>
        <IconButton>
          <Iconify
            icon="tabler:trash"
            color={theme => theme.palette.background.primaryRed1}
            onClick={
              () => methods.setValue('interactiveInterview.showInteractiveInterview', false)
            }
          />
        </IconButton>
      </Stack>
      <Stack spacing="6px">
        <Typography variant="subheading2" fontSize={16}>
          What do you want to evaluate?
        </Typography>
        <RHFTextField
          name="interactiveInterview.criteriaText"
          multiline
          rows={4}
          fullWidth
          placeholder="Enter text"
        />
      </Stack>
    </Stack>
  );
}

InteractiveInterview.propTypes = {
  methods: PropTypes.object.isRequired,
};
